<template>
	<div class="px-4 formField" v-if="isVisible">
		<v-select
			:disabled="formField.Readonly"
			:items="statusItems"
			v-model="selectedValue"
			item-value="id"
			item-text="text"
			hide-details="auto"
			:rules="validationRules"
			:error-messages="validationError"
			:label="formField.Label"
		>
			<template v-slot:prepend v-if="visibleBubble || visibleHelp">
				<div v-if="visibleBubble">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								tabindex="-1"
								>mdi-information-outline</v-icon
							>
						</template>
						{{ bubbleText }}
					</v-tooltip>
				</div>
				<div v-if="visibleHelp">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								tabindex="-1"
								>mdi-help-circle-outline</v-icon
							>
						</template>
						{{ helpText }}
					</v-tooltip>
				</div>
			</template>
		</v-select>
	</div>
</template>
<script>
import { approvalStatus } from '../../../../enums/approvalStatus';
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
export default {
	name: 'ApprovalStatusField',
	mixins: [formFieldMixin],
	props: {
		formField: Object,
	},
	data() {
		return {
			statusItems: [
				{ id: approvalStatus.None, text: 'None' },
				{ id: approvalStatus.Pending, text: 'Pending' },
				{ id: approvalStatus.Approved, text: 'Approved' },
			],
		};
	},
	mounted() {
		this.defaultRules.push((v) => {
			if (this.formField.Required && !this.isBulkEdit) {
				if (!v) return false || 'The value is required';
				else return true;
			} else return true;
		});
		if (this.recordSelectedValue) {
			this.selectedValue = this.recordSelectedValue;
		}
	},
	methods: {
		onRecordChanged() {
			if (
				this.recordSelectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = this.recordSelectedValue;
				return;
			}

			if (
				this.selectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = null;
			}
		},
		onHideFormField() {
			this.selectedValue = null;
		},
		onSelectedValueChanged(newVal) {
			this.skipNextRecordUpdate = true;
			this.$emit('selectedValueChanged', [
				{ key: this.recordKeys[0], value: newVal },
			]);
		},
		onSetInteraction(setValue) {
			this.onSelectedValueChanged(setValue);
		},
		onClearInteraction() {
			this.onSelectedValueChanged(null);
		},
	},
};
</script>
